import Stack from '@mui/material/Stack'
import { type SxProps } from '@mui/material/styles'

import { Trophy } from '@mxenabled/mx-icons'
import { H2, P } from '@mxenabled/mxui'

interface EmptyWidgetProps {
  header: string
  subText: string
  sx?: SxProps
}

export const GoalsMicroEmptyState = ({ header, subText, sx }: EmptyWidgetProps) => (
  <Stack
    sx={{
      alignItems: 'center',
      alignSelf: 'center',
      px: 24,
      ...sx,
    }}
  >
    <Trophy size={32} />
    <H2 fontSize={15} fontWeight={600}>
      {header}
    </H2>
    <P
      color="text.secondary"
      sx={{ fontWeight: 400, maxWidth: { sm: 424 }, textAlign: 'center' }}
      variant="subtitle2"
    >
      {subText}
    </P>
  </Stack>
)
